module.exports = __webpack_public_path__ + "img/succeed-icon.fa9a411c.png";